import CustomModal from './CustomModal';
import {
  ProductVerificationModalProps,
  OrderStatusCode,
} from '../interface/interface';

export default function ProductVerificationModal({
  isOpen,
  onClose,
  onVerifyNow,
  scanCheckTargetStatusId,
}: Readonly<ProductVerificationModalProps>) {
  return (
    <CustomModal
      isOpen={isOpen}
      onClose={onClose}
      header="Product Scan Check"
      footer={
        <div className="flex">
          <button
            className="text-sm px-3 py-2 bg-primary-blue-500 border border-primary-blue-500 text-white rounded-md mr-3"
            onClick={onVerifyNow}
          >
            Verify Now
          </button>
          <button
            className="text-sm px-3 py-2 bg-white border border-primary-blue-500 text-primary-blue-500 rounded-md"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      }
      modalSize="w-10/12 md:w-5/12 3xl:w-3/12"
    >
      <div className="flex flex-col">
        <p className="text-sm text-primary-blue-500 mb-4 p-0 m-0">
          {`Some products in this order have not been verified. Please verify all products before ${
            scanCheckTargetStatusId === OrderStatusCode.SHIPPED
              ? 'marking this order as Shipped'
              : 'moving this order to Ready for Shipping'
          }.`}
        </p>
      </div>
    </CustomModal>
  );
}
